import * as T from "../Types";
import * as TC from "../textCode";

export const SourceTypes = {
    datasets: [
        { label: TC.DATASOURCE_DATASETS_SOURCES_FTP, value: "ftp" },
        { label: TC.DATASOURCE_DATASETS_SOURCES_ORES, value: "ores" },
        { label: TC.DATASOURCE_DATASETS_SOURCES_SIBELGA, value: "sibelga" },
    ] as T.Option<object, T.DataSource["source_type"]>[],
    documents: [
        { label: TC.DATASOURCE_DOCUMENTS_SOURCES_BTV, value: "api_btv" },
        { label: TC.DATASOURCE_DOCUMENTS_SOURCES_SGS, value: "api_sgs" },
        { label: TC.DATASOURCE_DOCUMENTS_SOURCES_FTP, value: "ftp" },
    ] as T.Option<object, T.DataSource["source_type"]>[],
    exports: [
        { label: TC.DATASOURCE_EXPORTS_TYPES_MAIL, value: "mail" },
    ] as T.Option<object, T.DataSource["export_type"]>[],
} as const;